import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Checkbox, Input, Typography } from 'antd'
import { useSelector } from 'react-redux'

const { Title } = Typography

const SERVICE_OPTIONS = [
	{ field: 'fedex_freight_direct_economy_basic', label: 'FedEx freight direct economy basic', defaultLabel: 'Fedex Freight Direct Economy Basic' },
	{ field: 'fedex_freight_direct_priority_basic', label: 'FedEx freight direct priority basic', defaultLabel: 'Fedex Freight Direct Priority Basic' },
	{ field: 'fedex_freight_direct_economy_basic_appointment', label: 'FedEx freight direct economy basic by appointment', defaultLabel: 'Fedex Freight Direct Economy Basic By Appointment' },
	{ field: 'fedex_freight_direct_priority_basic_appointment', label: 'FedEx freight direct priority basic by appointment', defaultLabel: 'Fedex Freight Direct Priority Basic By Appointment' },
	{ field: 'fedex_freight_direct_priority_standard', label: 'FedEx freight direct priority standard', defaultLabel: 'Fedex Freight Direct Priority Standard' },
	{ field: 'fedex_freight_direct_priority_premium', label: 'FedEx freight direct priority premium', defaultLabel: 'Fedex Freight Direct Priority Premium' },
]

export const FREIGHT_DIRECT_SERVICE_FIELDS = SERVICE_OPTIONS.map(option => option.field)

const FreightDirectServices = ({
	quoteSettingsState,
	handleChange,
	selectAllFreightDirectOptions,
	toggleFreightDirectOption,
	radStatus,
}) => {
	const { radSettings } = useSelector(state => state)
	const [radAutoDetect, setRadAutoDetect] = useState(false)

	useEffect(() => {
		if (radSettings?.settings) {
			const settings = JSON.parse(radSettings.settings) ?? null
			if (settings && settings.residential_delivery_auto_detect) {
				setRadAutoDetect(settings.residential_delivery_auto_detect)
			}
		}
	}, [radSettings])

	const residentialOnlyDisabled = !radStatus || !radAutoDetect

	return (
		<>
			<div style={{ marginBottom: 24 }}>
				<Row gutter={30} align='middle'>
					<Col className='gutter-row' xs={24} sm={12} md={12} lg={12} xl={6}>
						<label className={'text-gray'}>
							Quote Freight Direct Services only to residential addresses
						</label>
					</Col>
					<Col className='gutter-row' xs={24} sm={12} md={12} lg={12} xl={18}>
						<Form.Item className={'mb-0'}>
							<Checkbox
								name='freight_direct_residential_only'
								checked={quoteSettingsState.freight_direct_residential_only}
								onChange={e =>
									handleChange('freight_direct_residential_only', e.target.checked)
								}
								disabled={residentialOnlyDisabled}
							/>
								<label className={'text-gray'} style={{ marginLeft: '10px' }}>
									Requires Automatically detect residential addresses feature
								</label>
						</Form.Item>
					</Col>
				</Row>
			</div>

			<Row gutter={30} align='middle' className={'mb-4'}>
				<Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={24}>
					<Title level={4}>Quote service options</Title>
				</Col>
				<Col className='gutter-row' xs={24} sm={12} md={12} lg={12} xl={6}>
					<label className={'text-gray'}>Select all</label>
				</Col>
				<Col className='gutter-row' xs={24} sm={12} md={12} lg={12} xl={18}>
					<Form.Item className={'mb-0'}>
						<Checkbox
							name='fedex_freight_direct_select_all'
							checked={quoteSettingsState.fedex_freight_direct_select_all}
							onChange={e => selectAllFreightDirectOptions(e.target.checked)}
						/>
					</Form.Item>
				</Col>

				{SERVICE_OPTIONS.map(({ field, label, defaultLabel }) => (
					<React.Fragment key={field}>
						<Col className='gutter-row' xs={24} sm={12} md={12} lg={12} xl={6}>
							<label className={'text-gray'}>{label}</label>
						</Col>
						<Col className='gutter-row' xs={24} sm={12} md={12} lg={12} xl={18}>
							<Form.Item className={'mb-0'}>
								<Checkbox
									name={field}
									checked={quoteSettingsState[field]}
									onChange={e => toggleFreightDirectOption(e.target.checked, field)}
								/>
							</Form.Item>
							<Form.Item className={'mb-0'}>
								<Input
									value={quoteSettingsState[`${field}_label`]}
									onChange={e => handleChange(`${field}_label`, e.target.value)}
									maxLength={50}
								/>
							</Form.Item>
							<div className={'text-gray'}>
								What the user sees during checkout, e.g. "Freight". If left blank will default to "{defaultLabel}".
							</div>
						</Col>
					</React.Fragment>
				))}
			</Row>
		</>
	)
}

export default FreightDirectServices
